import React from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

const FAQItem = ({ question, answer, isOpen, toggle }) => {
    return (
        <div className="border border-gray-200 dark:border-gray-800 rounded-xl overflow-hidden transition-all duration-300 hover:border-blue-300 dark:hover:border-blue-700">
            <button
                onClick={toggle}
                className={`w-full flex items-center justify-between p-5 text-left font-semibold text-gray-900 dark:text-white transition-colors ${isOpen ? 'bg-gray-50 dark:bg-gray-900/50' : 'bg-white dark:bg-[#0F1623]'
                    }`}
            >
                <span className="text-lg">{question}</span>
                {isOpen ? <FaChevronUp className="text-blue-500" /> : <FaChevronDown className="text-gray-400" />}
            </button>
            <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
            >
                <div className="p-5 pt-0 bg-gray-50 dark:bg-gray-900/50 text-gray-600 dark:text-gray-300 leading-relaxed">
                    {answer}
                </div>
            </div>
        </div>
    );
};

export default FAQItem;
